// QA 2026-04-29 (批次一 F1)：统一 API 错误透传逻辑。
// 历史背景：RegisterPage.js 提交时如果命中 ERR_CONNECTION_CLOSED（QA 报告 P0 网络问题），
// err.response 为 undefined，旧文案"请检查网络连接"会让用户以为是自己的网络问题，
// 实际是生产侧 SSL/keepalive 抖动；同时多个页面（Register / ProfileSetup / Login）
// 各自实现一份字段错误展开逻辑，容易写偏。这里抽成 util 复用。
//
// 入参：err 是 axios catch 块拿到的 error 对象
// 入参：opts.fieldLabels 把 DRF serializer 字段名映射为中文（可选）
// 出参：可直接 setError(msg) 的字符串

const DEFAULT_FALLBACK = '操作失败，请稍后重试';

/**
 * 把 axios 错误转成可直接展示给用户的中文字符串。
 *
 * 优先级：
 *  1. 没有 err.response → 网络层失败（连接被切 / DNS / CORS 等），区分 5xx 和无响应
 *  2. 字符串响应（500 HTML 错误页等） → 走兜底文案
 *  3. data.detail → 直接用
 *  4. 字段错误对象 {password: ['...'], email: ['...']} → 按字段拼接
 */
export function parseApiError(err, opts = {}) {
  const { fieldLabels = {}, fallback = DEFAULT_FALLBACK } = opts;
  const status = err?.response?.status;
  const d = err?.response?.data;

  // 1. 无响应：ERR_CONNECTION_CLOSED / 超时 / DNS 失败等
  //    Phase G.1 后改：不再说"检查网络连接"，避免把生产侧问题甩给用户
  if (!d) {
    if (status >= 500) return '服务器繁忙，请稍后重试';
    return '服务器连接异常，请稍后重试';
  }

  // 2. data 是字符串（多见于 Django 默认 500 HTML 页）
  if (typeof d === 'string') {
    return status >= 500 ? '服务器内部错误，请稍后重试' : fallback;
  }

  // 3. DRF 标准 detail
  if (d.detail) return String(d.detail);

  // 4. 字段错误：{field: ['msg', 'msg']}
  if (typeof d === 'object' && !Array.isArray(d)) {
    const IGNORE = new Set(['error_code']);  // 机器字段（class-stream），不展示给用户
    const msgs = Object.entries(d)
      .filter(([field]) => !IGNORE.has(field))
      .map(([field, errs]) => {
        const label = fieldLabels[field] || field;
        const text = Array.isArray(errs) ? errs.join(' ') : String(errs);
        return label ? `${label}：${text}` : text;
      })
      .filter(Boolean)
      .join('；');
    return msgs || fallback;
  }

  return fallback;
}
